var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.828,
    height: 79.828,
    viewBox: "0 0 79.828 79.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #1e5288;\n        stroke-width: 2px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(-359.086 -5476.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(360 5477)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1200",
    "data-name": "Line 1200",
    className: "cls-1",
    x2: 15.676,
    y2: 15.219,
    transform: "translate(61.004 1.279)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1201",
    "data-name": "Line 1201",
    className: "cls-1",
    x2: 16,
    y2: 16,
    transform: "translate(0.5 61.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-1",
    d: "M208.329,1087.7h-77v-76.985l77-.015v77",
    transform: "translate(-130.829 -1010.197)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1202",
    "data-name": "Line 1202",
    className: "cls-2",
    x2: 28,
    y2: 27,
    transform: "translate(49.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-2",
    d: "M171.058,1089.348l-38.1-38,38.1-38,38.9,37.137Z",
    transform: "translate(-132.462 -1012.848)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1203",
    "data-name": "Line 1203",
    className: "cls-2",
    x2: 28,
    y2: 28,
    transform: "translate(0.5 49.5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1204",
    "data-name": "Line 1204",
    className: "cls-3",
    x2: 19.899,
    y2: 18.743,
    transform: "translate(56.601 57.757)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1205",
    "data-name": "Line 1205",
    className: "cls-3",
    x2: 19,
    y2: 19,
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape-2.857fc5d125f6e9129484407148418b54.svg";
export { ForwardRef as ReactComponent };